import { Flex } from '@chakra-ui/react';
import React from 'react';
import { useDrag } from 'react-dnd';

interface DragItemProps {
  type: string;
  children: React.ReactNode;
}

const DragItem: React.FC<DragItemProps> = ({ type, children }) => {
  const [{ isDragging }, drag] = useDrag({
    type: 'form-element',
    item: { type },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  return (
    <div
      ref={drag}
      style={{
        opacity: isDragging ? 0.5 : 1,
        cursor: 'move',
        border: "2px solid #e2e8f0" ,
        padding: 6,
      }}
      
    >
      <Flex gap={2} alignItems="center">
      {children}
      </Flex>
    </div>
  );
};

export default DragItem;
